import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'dmmp-simple-link',
  templateUrl: './simple-link.component.html'
})
export class SimpleLinkComponent {

  @Input() data
  @Input() identifier
  @Input() defaultClass
  @Output() page = new EventEmitter()

}
